"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8517],{

/***/ 97404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ImageProcessor; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_urlToHttp__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49556);






// const AWS_URL = 'https://image-compression-handler.s3.us-west-1.amazonaws.com/';
var AWS_CLOUDFRONT_URL = "https://d3v21378787kni.cloudfront.net/";
function ImageProcessor(_param) {
    var src = _param.src, size = _param.size, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "src",
        "size"
    ]);
    // pass into src the url to the image
    // src format : ipfs://QmWjY...
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), load = ref[0], setLoad = ref[1];
    var image_hash = src === null || src === void 0 ? void 0 : src.split("//")[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        src: AWS_CLOUDFRONT_URL + image_hash + "=" + size,
        onError: function(param) {
            var currentTarget = param.currentTarget;
            currentTarget.onerror = null; // prevents looping
            currentTarget.src = (0,_utils_urlToHttp__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(src);
        }
    }, props), {
        alt: "karatDao",
        style: load ? {
            visibility: "visible"
        } : {
            visibility: "hidden"
        },
        onLoad: function() {
            return setLoad(true);
        }
    }));
}


/***/ }),

/***/ 87655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _usedapp_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24627);
/* harmony import */ var _ethersproject_contracts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64146);
/* harmony import */ var _chain_info_contracts_AirdropDistributor_json__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28801);
/* harmony import */ var _chain_info_contracts_NFTAirdropDistributor_json__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91704);
/* harmony import */ var ethers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8198);
/* harmony import */ var ethers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9279);






var useCampaignInfo = function(campaignType, addresses, chainId) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), error = ref[0], setError = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), campaignInfo = ref1[0], setCampaignInfo = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), loading = ref2[0], setLoading = ref2[1];
    // const [resultsTest, setResultsTest] = useState<any[]>([]);
    // const [resultsTest2, setResultsTest2] = useState<any[]>([]);
    var airdropDistributorAbi = _chain_info_contracts_AirdropDistributor_json__WEBPACK_IMPORTED_MODULE_1__/* .abi */ .Mt;
    var nftAirdropDistributorAbi = _chain_info_contracts_NFTAirdropDistributor_json__WEBPACK_IMPORTED_MODULE_2__/* .abi */ .Mt;
    var abi = campaignType === "TOKEN" ? airdropDistributorAbi : nftAirdropDistributorAbi;
    var contractInterface = new ethers__WEBPACK_IMPORTED_MODULE_3__/* .Interface */ .vU(abi);
    var airdropDistributorContract = addresses === null || addresses === void 0 ? void 0 : addresses.map(function(address) {
        return new _ethersproject_contracts__WEBPACK_IMPORTED_MODULE_4__.Contract(address !== null && address !== void 0 ? address : ethers__WEBPACK_IMPORTED_MODULE_5__/* .AddressZero */ .d, contractInterface);
    });
    var tokenQueries = [
        "name",
        "owner",
        "reach",
        "token",
        "merkleRoot",
        "isActive",
        "frozenInfoURI",
        "baseInfoURI",
        "claimedNum", 
    ];
    var nftQueries = [
        "name",
        "owner",
        "reach",
        "maxSupply",
        "merkleRoot",
        "isActive",
        "frozenInfoURI",
        "baseInfoURI",
        "claimedNum", 
    ];
    // console.log("address", addresses);
    var queries = campaignType === "TOKEN" ? tokenQueries : nftQueries;
    var ref3, ref4;
    var calls = (ref4 = addresses === null || addresses === void 0 ? void 0 : addresses.map(function(address, idx) {
        return (ref3 = queries === null || queries === void 0 ? void 0 : queries.map(function(query) {
            return address && {
                contract: airdropDistributorContract[idx],
                method: query,
                args: []
            };
        })) !== null && ref3 !== void 0 ? ref3 : [];
    })) !== null && ref4 !== void 0 ? ref4 : [];
    var // @ts-ignore
    ref5;
    // console.log("id here ",chainId);
    // const results = useCalls(calls.flat()) ?? []; //FIXME chainId won't trigger useCalls update
    var results = (ref5 = (0,_usedapp_core__WEBPACK_IMPORTED_MODULE_6__/* .useCalls */ .G)(calls[0] !== undefined ? calls === null || calls === void 0 ? void 0 : calls.flat() : [], {
        chainId: chainId
    })) !== null && ref5 !== void 0 ? ref5 : [];
    // console.log('results:',results);
    // const results = useCalls(calls.flat(), { isStatic: true }) ?? [];
    // console.log('results:', results);
    // console.log('results:', chainId, typeof chainId, calls, results);
    var groupByN = function(n, data) {
        var result = [];
        for(var i = 0; i < data.length; i += n){
            if (data[i] !== undefined) {
                result.push(data === null || data === void 0 ? void 0 : data.slice(i, i + n));
            } else {
                continue;
            }
        }
        return result;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // console.log('HERE1', loading);
        setLoading(true);
        var areAllNotUndefined = results === null || results === void 0 ? void 0 : results.every(function(i) {
            return i !== undefined;
        });
        if (areAllNotUndefined) {
            var campaignResults = groupByN(queries.length, results.map(function(result) {
                return result === null || result === void 0 ? void 0 : result.value;
            }));
            // console.log('campaignResults:', campaignResults);
            var data = campaignResults === null || campaignResults === void 0 ? void 0 : campaignResults.map(function(campaignResult, i) {
                var obj = {};
                queries === null || queries === void 0 ? void 0 : queries.map(function(query, index) {
                    return obj[query] = campaignResult[index][0];
                });
                obj["address"] = addresses[i];
                obj["type"] = campaignType;
                obj["chainId"] = chainId;
                return obj;
            });
            setCampaignInfo(data);
            setLoading(false);
        }
        // console.log('HERE2', loading);
        results.forEach(function(result, idx) {
            if (result && result.error) {
                var err = "Error encountered calling '".concat(queries[idx], "' on ").concat(addresses[idx], ": ").concat(result.error.message);
                setError(err);
                console.error(err);
                setLoading(false);
            }
        });
    // console.log('HERE3', loading);
    // eslint-disable-next-line
    }, [
        results,
        chainId
    ]);
    // useEffect(() => {
    //   console.log('HERE4', loading);
    // }, [loading]);
    // FIXME 0608 When you switch from another chain to the campaign chain, it will forever load. Temp workaround so far
    return {
        campaignInfo: campaignInfo,
        error: error,
        loading: loading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useCampaignInfo);


/***/ }),

/***/ 82741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_urlToHttp__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49556);





var useFetchData = function(url) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), error = ref1[0], setError = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), data = ref2[0], setData = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var fetchData = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(_url) {
                var response, resData, error;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            setLoading(true);
                            return [
                                4,
                                axios__WEBPACK_IMPORTED_MODULE_1___default().get(_url)
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                4,
                                response.data
                            ];
                        case 2:
                            resData = _state.sent();
                            setData(resData);
                            setLoading(false);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            setError(error);
                            setLoading(false);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData(_url) {
                return _ref.apply(this, arguments);
            };
        }();
        if (url) {
            fetchData((0,_utils_urlToHttp__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(url)[0]);
        }
    }, [
        url
    ]);
    return {
        loading: loading,
        error: error,
        data: data
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useFetchData);


/***/ }),

/***/ 49556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ uriToHttp; }
/* harmony export */ });
/**
 * Given a URI that may be ipfs, ipns, http, https, ar, or data protocol, return the fetch-able http(s) URLs for the same content
 * @param uri to convert to fetch-able http url
 */ function uriToHttp(uri) {
    var protocol = uri === null || uri === void 0 ? void 0 : uri.split(":")[0].toLowerCase();
    switch(protocol){
        case "data":
            return [
                uri
            ];
        case "https":
            return [
                uri
            ];
        case "http":
            return [
                "https" + uri.substr(4),
                uri
            ];
        case "ipfs":
            var ref;
            var hash = (ref = uri.match(/^ipfs:(\/\/)?(.*)$/i)) === null || ref === void 0 ? void 0 : ref[2];
            return [
                "https://karatdao.mypinata.cloud/ipfs/".concat(hash, "/")
            ];
        case "ipns":
            var ref1;
            var name = (ref1 = uri.match(/^ipns:(\/\/)?(.*)$/i)) === null || ref1 === void 0 ? void 0 : ref1[2];
            return [
                "https://ipfs.io/ipns/".concat(name, "/")
            ];
        case "ar":
            var ref2;
            var tx = (ref2 = uri.match(/^ar:(\/\/)?(.*)$/i)) === null || ref2 === void 0 ? void 0 : ref2[2];
            return [
                "https://arweave.net/".concat(tx)
            ];
        default:
            return [];
    }
}


/***/ }),

/***/ 93171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ KARATDAO_DEFAULT_SUPPORTED_CHAINS; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29815);
/* harmony import */ var _usedapp_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62990);
/* harmony import */ var _chain_info_KCCChain__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81474);
/* harmony import */ var _chain_info_ZetaChain__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98982);




_usedapp_core__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_SUPPORTED_CHAINS.forEach */ .B.forEach(function(chain) {
    if (chain.chainId === 324) {
        chain.getExplorerAddressLink = function(address) {
            return "https://explorer.zksync.io/address/".concat(address);
        };
        chain.getExplorerTransactionLink = function(hash) {
            return "https://explorer.zksync.io/tx/".concat(hash);
        };
    }
});
var KARATDAO_DEFAULT_SUPPORTED_CHAINS = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_usedapp_core__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_SUPPORTED_CHAINS */ .B).concat([
    _chain_info_KCCChain__WEBPACK_IMPORTED_MODULE_0__/* .KCCChain */ .qI,
    _chain_info_KCCChain__WEBPACK_IMPORTED_MODULE_0__/* .KCCChain_Test */ .VI,
    _chain_info_ZetaChain__WEBPACK_IMPORTED_MODULE_1__/* .ZetaChain_Test */ .O, 
]);


/***/ }),

/***/ 28801:
/***/ (function(module) {

module.exports = JSON.parse('{"Mt":[{"inputs":[{"internalType":"string","name":"_name","type":"string"},{"internalType":"address","name":"_owner","type":"address"},{"internalType":"address","name":"_token","type":"address"},{"internalType":"bytes32","name":"_merkleRoot","type":"bytes32"},{"internalType":"uint256","name":"_reach","type":"uint256"},{"internalType":"string","name":"_baseInfoURI","type":"string"},{"internalType":"string","name":"_frozenInfoURI","type":"string"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"},{"indexed":true,"internalType":"string","name":"newBaseInfoURI","type":"string"}],"name":"BaseInfoURIUpdated","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"}],"name":"CampaignStopped","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"},{"indexed":true,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Claimed","type":"event"},{"inputs":[],"name":"baseInfoURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"bytes32[]","name":"merkleProof","type":"bytes32[]"}],"name":"claim","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"claimed","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"claimedNum","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"frozenInfoURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"isActive","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"merkleRoot","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"reach","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"stopCampaign","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"token","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"string","name":"_baseInfoURI","type":"string"}],"name":"updateBaseInfoURI","outputs":[],"stateMutability":"nonpayable","type":"function"}]}');

/***/ }),

/***/ 91704:
/***/ (function(module) {

module.exports = JSON.parse('{"Mt":[{"inputs":[{"internalType":"string","name":"name","type":"string"},{"internalType":"address","name":"_owner","type":"address"},{"internalType":"bytes32","name":"_merkleRoot","type":"bytes32"},{"internalType":"uint256","name":"_reach","type":"uint256"},{"internalType":"uint256","name":"_maxSupply","type":"uint256"},{"internalType":"string","name":"_baseInfoURI","type":"string"},{"internalType":"string","name":"_frozenInfoURI","type":"string"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"approved","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"},{"indexed":true,"internalType":"string","name":"newBaseInfoURI","type":"string"}],"name":"BaseInfoURIUpdated","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"}],"name":"CampaignStopped","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"},{"indexed":true,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Claimed","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[],"name":"_tokenIdTracker","outputs":[{"internalType":"uint256","name":"_value","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"approve","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"baseInfoURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"bytes32[]","name":"merkleProof","type":"bytes32[]"}],"name":"claim","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"claimed","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"claimedNum","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"frozenInfoURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getApproved","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"isActive","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"maxSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"merkleRoot","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ownerOf","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"reach","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"stopCampaign","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenOfOwnerByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"tokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"transferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"_baseInfoURI","type":"string"}],"name":"updateBaseInfoURI","outputs":[],"stateMutability":"nonpayable","type":"function"}]}');

/***/ })

}]);